var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1870,
    transform: "translate(-482 -802)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#108AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 6.33325V8.99992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 6.33325V8.99992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14.3334V9.00008C19 8.64646 18.8595 8.30732 18.6095 8.05727C18.3594 7.80722 18.0203 7.66675 17.6667 7.66675H8.33333C7.97971 7.66675 7.64057 7.80722 7.39052 8.05727C7.14048 8.30732 7 8.64646 7 9.00008V18.3334C7 18.687 7.14048 19.0262 7.39052 19.2762C7.64057 19.5263 7.97971 19.6667 8.33333 19.6667H13.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.6667H19",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 18.3333L17.0003 19.6667L19.667 17",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1870,
    fill: "white",
    transform: "translate(-482 -802)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/created.9e44bfe8ed70a134f9f7d70f26f7c5e6.svg";
export { ForwardRef as ReactComponent };